import React, { useEffect, useMemo, useState } from 'react';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import { Box, Button, Grid, Stack } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useDispatch } from 'react-redux';
import { getAlldepartments } from '../../../../redux/features/generalSlice';
import { useSelector } from 'react-redux';
import GlobalSelectField from '../../../../components/mui/GlobalSelectField';
import { useFormik } from 'formik';
import dayjs from 'dayjs';
import { getFilter } from './utils/getFilter';
import DahsboardCard from '../../../crm/myworkspace/Dashboard/DahsboardCard';
import { getCardData } from './utils/getCardData';
import { getLeaveAnalyticsWithCounts } from '../../../../redux/features/leaveSlice';
import GlobalDataGrid from '../../../../components/mui/DataGrid/GlobalDatagrid';
import CardSkelton from '../../../../components/Skeleton/CardSkelton';

export default function LeaveAnalytics() {
  const dispatch = useDispatch();
  const { alldepartments: allDepartments } = useSelector((state) => state.general);
  const {
    paginationData: { gridSize, pageNum, search },
  } = useSelector((state) => state.globalDataGrid);

  const {
    leaveAnalytics: { cardData, userDetails },
    meta,
    loading,
  } = useSelector((state) => state.leave);
  const [change, setChange] = useState(false);

  const handleFilter = (e) => setChange((p) => !p);

  const formik = useFormik({
    initialValues: {
      startDate: dayjs().startOf('month').format('YYYY-MM-DD'),
      endDate: dayjs().endOf('month').format('YYYY-MM-DD'),
      department: '',
      status: 1,
    },
    onSubmit: handleFilter,
  });

  useEffect(() => {
    dispatch(getLeaveAnalyticsWithCounts({ limit: gridSize, page: pageNum, search, ...formik.values }));
  }, [change, gridSize, pageNum, search]);

  useEffect(() => {
    dispatch(getAlldepartments());
  }, []);

  const Filters = useMemo(() => getFilter(allDepartments), [allDepartments]);

  const leaveColumns = [
    { field: 'name', headerName: 'Employee Name', width: 200 },
    { field: 'dept_name', headerName: 'Department', width: 200 },
    { field: 'designation_name', headerName: 'Designation', width: 200 },
    // { field: 'probation_completed_on', headerName: 'Probation Completed On', width: 200 },
    // { field: 'leave_types', headerName: 'Leave Type', width: 200 },
    { field: 'CompensatoryOff', headerName: 'Compensatory Off', width: 200 },
    { field: 'WorkFromHome', headerName: 'Work From Home (WFH)', width: 200 },
    { field: 'LeaveCasualLeave', headerName: 'Leave-Casual Leave', width: 200 },
    { field: 'LeaveSickLeave', headerName: 'Leave-Sick Leave', width: 200 },
    { field: 'LeavePaidLeave', headerName: 'Leave-Paid Leave', width: 200 },
    { field: 'LeaveMaternityLeave', headerName: 'Leave-Maternity Leave', width: 200 },
    { field: 'LeaveWithoutPay', headerName: 'Leave Without Pay', width: 200 },
    { field: 'LeaveDotLeave', headerName: 'Leave-Dot Leave', width: 200 },
    { field: 'LeaveEarnedLeave', headerName: 'Leave-Earned Leave', width: 200 },
    { field: 'totalLeave', headerName: 'Total Leaves', width: 200 },
  ];

  return (
    <GlobalWrapper title={'Leave Analytics'}>
      <Stack mb={4}>
        {loading ? (
          <CardSkelton
            height={120}
            width={'100%'}
            spacing={2}
            variant="rectangular"
            borderRadius={2}
            mutliCard={{
              count: 9,
              size: {
                xl: 2,
                lg: 3,
                sm: 6,
                md: 4,
                xs: 12,
              },
            }}
          />
        ) : (
          <Grid container spacing={1}>
            {getCardData.map((e, i) => (
              <Grid item xl={2.4} lg={3} sm={6} md={4} xs={12} key={i}>
                <DahsboardCard title={e.title} value={cardData?.[e.key] ?? 0} height={120} />
              </Grid>
            ))}
          </Grid>
        )}
      </Stack>

      <Box display={'flex'} justifyContent={'space-between'} mb={3}>
        <Box display={'flex'} gap={1} flexGrow={1}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              sx={{ maxWidth: 200, width: '100%' }}
              label="From Date"
              value={dayjs(formik.values.startDate)}
              onChange={(e) => formik.setFieldValue('startDate', e?.format('YYYY-MM-DD'))}
              disableFuture
            />
            <DatePicker
              sx={{ maxWidth: 200, width: '100%' }}
              label="ToDate"
              value={dayjs(formik.values.endDate)}
              onChange={(e) => formik.setFieldValue('endDate', e?.format('YYYY-MM-DD'))}
            />
          </LocalizationProvider>
          {Filters.map(({ label, data, keys, name }, i) => (
            <GlobalSelectField
              key={i}
              options={{
                sx: {
                  width: '100%',
                  maxWidth: 200,
                },
                name,
                formik,
                label,
                data,
                keys,
              }}
            />
          ))}
        </Box>

        <Button variant="contained" onClick={() => formik.submitForm()}>
          Apply Filter
        </Button>
      </Box>
      <GlobalDataGrid
        rows={userDetails ?? []}
        tableHead={leaveColumns}
        rowUniqueId={'sl_no'}
        meta={meta?.totalRecords}
      />
    </GlobalWrapper>
  );
}
